import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import CemiterioListActions from '../ducks/cemiterio-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = state => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-cemiterio`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(CemiterioListActions.success(data, pagination));
  } catch (err) {
    yield put(CemiterioListActions.failure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/ld-cemiterio?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, nome }) => ({
      value: uuid,
      label: nome,
    }));

    yield put(CemiterioListActions.showSuccess(list));
  } catch (err) {
    yield put(
      CemiterioListActions.showFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
